var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F9FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.8551 65.6887C36.8307 65.6887 36.8082 65.6887 36.7819 65.6868C36.1913 65.6568 35.6119 65.5293 35.0607 65.3062C32.3476 64.2037 31.0388 61.1043 32.1394 58.3931L45.8663 34.3443C46.3388 33.4893 47.0551 32.7731 47.9288 32.2893C50.4882 30.8718 53.7244 31.8037 55.1401 34.3612L68.7769 58.2262C69.0807 58.9406 69.2101 59.5218 69.2419 60.1143C69.3151 61.5318 68.8313 62.8912 67.8826 63.9431C66.9338 64.9949 65.6307 65.6156 64.2151 65.6868L36.9901 65.6887H36.8551Z",
    fill: "#4286F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8584 44.7889C48.8584 43.8852 49.5953 43.1483 50.4991 43.1483C51.4028 43.1483 52.1397 43.8852 52.1397 44.7889V50.0914C52.1397 50.9971 51.4028 51.7321 50.4991 51.7321C49.5953 51.7321 48.8584 50.9971 48.8584 50.0914V44.7889ZM48.8584 56.506C48.8584 55.5966 49.5953 54.856 50.4991 54.856C51.4028 54.856 52.1397 55.5873 52.1397 56.4854C52.1397 57.4098 51.4028 58.1466 50.4991 58.1466C49.5953 58.1466 48.8584 57.4098 48.8584 56.506Z",
    fill: "#4286F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.ef4ef99f8294effbdc9f429f3fc24cbd.svg";
export { ForwardRef as ReactComponent };